import { NetworkRequest } from "./NetworkRequest";
import { NetworkService } from "./NetworkService";

export default class ResetPasswordService {
    static async requestReset(email) {
        await NetworkService.request({
            alias: NetworkRequest.ResetPasswordRequest,
            url: "medidorapp/passwordemail",
            method: "POST",
            params: { email },
        });
    }

    static async getEmail(passwordResetCode) {
        return NetworkService.request({
            alias: NetworkRequest.ResetPasswordGetEmail,
            url: "users/passwordreset/validation",
            method: "GET",
            parms: { passwordResetCode },
        });
    }

    static async confirmReset(passwordCode, password) {
        return NetworkRequest.request({
            alias: NetworkRequest.ResetPasswordConfirm,
            url: "users/passwordreset",
            method: "POST",
            data: {
                passwordCode,
                password,
            },
        });
    }

    static async changePassword(passwordChangeDTO) {
        return NetworkService.request({
            alias: NetworkRequest.ChangePassword,
            url: "users/passwordchange",
            method: "POST",
            data: passwordChangeDTO,
            ignoreUnauthorizedError: true,
        });
    }
}